import axios from 'axios';
import { OktaAuth } from '@okta/okta-auth-js';
import Swal from 'sweetalert2';
import { loginConfirmedAction, Logout } from '../store/actions/AuthActions';
import axiosInstance from './AxiosInstance';

// Initialize OktaAuth instance
export const oktaAuth = new OktaAuth({
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  redirectUri: `${window.location.origin}${process.env.REACT_APP_OKTA_REDIRECT_URI}`,
  scopes: process.env.REACT_APP_OKTA_SCOPES?.split(' ') || ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: false,
});

export const signUp = (email, password) => {
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${process.env.REACT_APP_FIREBASE_API_KEY}`,
    { email, password, returnSecureToken: true }
  );
};

export const login = (sso, email, password, userInfo) => {
  const postData = sso
    ? { userInfo, returnSecureToken: true }
    : { email, password, returnSecureToken: true };
  return axiosInstance.post('/auth/login', postData);
};

export const getProfile = () => axiosInstance.get('/auth/getProfile');

export const forgotPassword = (payload) => axiosInstance.post('/auth/forgot-password', payload);

export const resetPassword = (payload) => axiosInstance.post('/auth/reset-password', payload);

export const changePassword = (payload) => axiosInstance.post('/auth/change-password', payload);

export const formatError = ({ error }) => {
  const errorMessages = {
    EMAIL_EXISTS: 'Email already exists',
    EMAIL_NOT_FOUND: 'Email not found',
    INVALID_PASSWORD: 'Invalid Password',
    USER_DISABLED: 'User Disabled',
  };

  const message = errorMessages[error.message] || 'An unexpected error occurred';

  Swal.fire({ icon: 'error', title: 'Oops', text: message });

  return message;
};

export const saveTokenInLocalStorage = async (tokenDetails) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
      resolve();
    }, 0); // defer execution to next event loop tick
  });
};

export const runLogoutTimer = (dispatch, timer, navigate) => {
  if (timer > 0) {
    setTimeout(() => dispatch(Logout(navigate)), timer);
  }
};

export const checkAutoLogin = (dispatch, navigate) => {
  const tokenDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  const expireDate = new Date(tokenDetails.expireIn);
  const now = new Date();

  if (!tokenDetails.token || now > expireDate) {
    dispatch(Logout(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));
  //runLogoutTimer(dispatch, expireDate.getTime() - now.getTime(), navigate);
};
